import ZingTouch from '../../lib/ZingTouch/ZingTouch';
import { get } from 'svelte/store';
import { getSetting } from '../../lib/useDB';
import { store } from '../../store';
export const LayoutType = {
    window: 0,
    control: 1
};
const useLayout = (container) => {
    const region = new ZingTouch.Region(container, false, true);
    const rects = [];
    const distanceCenters = [];
    const elements = Array(Object.values(LayoutType).length).map(_ => null);
    let isDragging = Array(Object.values(LayoutType).length).map(_ => false);
    const init = async () => {
        let s = await getSetting();
        for (const type of Object.values(LayoutType)) {
            if (type === LayoutType.window) {
                rects[type] = getNumRect(s.windowRect);
            }
            if (type === LayoutType.control) {
                rects[type] = getNumRect(s.controlRect);
            }
            distanceCenters.push({
                x: 0,
                y: 0
            });
        }
    };
    const setupHandler = (ele, type) => {
        elements[type] = ele;
        const onPanStart = (inputs) => {
            if (inputs.length === 0) {
                console.error('pan start error');
                return;
            }
            const initial = inputs[0].initial;
            isDragging = Array(Object.values(LayoutType).length).map(_ => false);
            rects.forEach((rect, i) => {
                if (rect.x < initial.x && initial.x < rect.x + rect.width && rect.y < initial.y && initial.y < rect.y + rect.height) {
                    isDragging[i] = true;
                }
            });
        };
        const onPanMove = (inputs, state, element, output) => {
            if (!output || output.data.length === 0) {
                return;
            }
            const draggingIndex = isDragging.findIndex(v => v === true);
            if (draggingIndex === -1) {
                return;
            }
            const data = output.data[0];
            rects[draggingIndex].x += data.change.x;
            rects[draggingIndex].y += data.change.y;
            const prev = get(store.setting);
            if (!prev)
                return;
            if (draggingIndex === LayoutType.window) {
                prev.windowRect = getRect(rects[draggingIndex]);
            }
            if (draggingIndex === LayoutType.control) {
                prev.controlRect = getRect(rects[draggingIndex]);
            }
            store.setting.set(prev);
        };
        const customPan = new ZingTouch.Pan({ onStart: onPanStart, onMove: onPanMove });
        region.bind(container, customPan, () => { });
        const onDistanceStart = (inputs, state, element) => {
            if (inputs.length < 2) {
                return;
            }
            distanceCenters[type] = {
                x: (inputs[0].current.x + inputs[1].current.x) / 2,
                y: (inputs[0].current.y + inputs[1].current.y) / 2,
            };
        };
        const onDistanceMove = (inputs, state, element, movement) => {
            if (!movement || inputs.length < 2) {
                return;
            }
            const change1 = getChange(distanceCenters[type], inputs[0]);
            const change2 = getChange(distanceCenters[type], inputs[1]);
            if (inputs[0].current.x < inputs[1].current.x) {
                rects[type].x -= change1.x;
                rects[type].y -= change1.y;
                rects[type].width += change1.x + change2.x;
                rects[type].height += change1.y + change2.y;
            }
            else {
                rects[type].x -= change2.x;
                rects[type].y -= change2.y;
                rects[type].width += change1.x + change2.x;
                rects[type].height += change1.y + change2.y;
            }
            const prev = get(store.setting);
            if (!prev)
                return;
            if (type === LayoutType.window) {
                prev.windowRect = getRect(rects[type]);
            }
            if (type === LayoutType.control) {
                prev.controlRect = getRect(rects[type]);
            }
            store.setting.set(prev);
        };
        const customDistance = new ZingTouch.Distance({ onStart: onDistanceStart, onMove: onDistanceMove });
        region.bind(ele, customDistance, () => { });
    };
    const setButton = (ele, callback) => {
        const rect = ele.getBoundingClientRect();
        const onTapEnd = (inputs, timing) => {
            if (inputs.length === 0) {
                console.error('no tap information');
                return;
            }
            const input = inputs[0];
            if (rect.x < input.current.x && input.current.x < rect.x + rect.width && rect.y < input.current.y && input.current.y < rect.y + rect.height) {
                callback();
            }
        };
        const customTap = new ZingTouch.Tap({ onEnd: onTapEnd });
        region.bind(container, customTap, () => { });
    };
    const dispose = () => {
        region.unbind(container);
    };
    return { init, setupHandler, setButton, dispose };
};
export const setTouch = (ele, callback) => {
    const region = new ZingTouch.Region(ele, false, true);
    region.bind(ele, 'tap', callback);
};
const getChange = (center, input) => {
    return {
        x: Math.abs(input.current.x - center.x) - Math.abs(input.previous.x - center.x),
        y: Math.abs(input.current.y - center.y) - Math.abs(input.previous.y - center.y)
    };
};
const getNumRect = (rect) => {
    return {
        x: conversionPX(rect.start.x, window === null || window === void 0 ? void 0 : window.innerWidth),
        y: conversionPX(rect.start.y, window === null || window === void 0 ? void 0 : window.innerHeight),
        width: conversionPX(rect.width, window === null || window === void 0 ? void 0 : window.innerWidth),
        height: conversionPX(rect.height, window === null || window === void 0 ? void 0 : window.innerHeight)
    };
};
const getRect = (numRect) => {
    return {
        start: {
            x: `${numRect.x}px`,
            y: `${numRect.y}px`
        },
        width: `${numRect.width}px`,
        height: `${numRect.height}px`
    };
};
const conversionPX = (str, base) => {
    if (str.endsWith('px')) {
        return Number(str.replace('px', ''));
    }
    if (str.endsWith('%')) {
        if (!base)
            return 500;
        return base * Number(str.replace('%', '')) / 100;
    }
    return 0;
};
export default useLayout;
